import clsx from 'clsx';
import styles from '../../RelatedParties.module.scss';
import { getImage, relationEdgeFallbackLabels, relationTypeMap } from '../../relatedParty_constants';
import { toTitleCase } from '../../../../../../utils/utils';
import { alertIcon, alertIconDisabled } from '../../../../../../assets/hostedassets';
import Tooltip from '../../../../../../common/_custom/Tooltip/Tooltip';
import EntityHoverCardTooltip from '../EntityHoverCard/EntityHoverCardTooltip';
import RowFinancialsDetails from '../EntityHoverCard/RowFinancialsDetails';
import { toRowFinancialsDetails } from '../EntityHoverCard/toEntityHoverProfile';
import EntityNameCell, { EntityNameLabel } from '../EntityNameCell/EntityNameCell';
import DisabledAlertsCell from '../DisabledAlertsCell/DisabledAlertsCell';

function SecondDegreeRow({ isPDFReport, entityEntry, row, handleAlertsClick, isProbeEnabled }) {
    const hasEntityHover = !isPDFReport && !!(row?.entityDetails || row?.aicaStatus);
    const rowFinancials = isPDFReport ? null : toRowFinancialsDetails(row?.aicaStatus, row?.type);
    const name = toTitleCase(row?.fromName) || '-';
    const nameText = <EntityNameLabel name={name} iconSrc={isPDFReport ? undefined : getImage(row?.type)} designation={row?.designation} />;
    const getRelationType = (parentType: string, childType: string, edgeType: string) => {
        return relationTypeMap[parentType]?.[childType]?.[edgeType] || relationEdgeFallbackLabels[edgeType] || '';
    };

    return (
        <tr className={clsx(styles.FirstDegreeRow, styles.SecondDegreeRow)} key={row?.fromKid}>
            <td className={styles.RowItem}></td>

            {/* polus computes relationLabel on the rows the static map cannot describe (a family edge's
                label depends on the director's gender); every other row still resolves through the map. */}
            <td className={styles.RowItem}>{row?.relationLabel || getRelationType(entityEntry?.type, row?.type, row?.edgeType) || ''}</td>

            <td className={styles.RowItem}>
                <EntityNameCell>
                    {hasEntityHover ? (
                        <EntityHoverCardTooltip row={row}>{nameText}</EntityHoverCardTooltip>
                    ) : (
                        <Tooltip
                            content={`${name}${row?.designation ? ` (${row.designation})` : ''}`}
                            direction="top"
                            contentCss={{ whiteSpace: 'nowrap' }}
                            fitContent
                            small
                            usePortal
                        >
                            {nameText}
                        </Tooltip>
                    )}
                </EntityNameCell>
            </td>

            {/* Details column: empty on degree-2 rows unless the entity is on AICA (financials / Locked). */}
            <td className={styles.RowItem}>{rowFinancials && <RowFinancialsDetails details={rowFinancials} row={row} />}</td>

            <td className={styles.RowItem}>
                <div
                    className={clsx(styles.Risk, {
                        [styles.Risk_Severe]: row?.risk === 'SEVERE',
                        [styles.Risk_High]: row?.risk === 'HIGH',
                        [styles.Risk_Medium]: row?.risk === 'MEDIUM',
                        [styles.Risk_Low]: row?.risk === 'LOW',
                    })}
                >
                    {row?.risk && row?.risk !== 'null' ? toTitleCase(row?.risk) : 'NA'}
                </div>
            </td>

            {!isPDFReport && <td className={styles.RowItem}></td>}

            {!isPDFReport && (
                <td className={styles.RowItem}>
                    {isProbeEnabled && !row?.alerts?.length ? (
                        <Tooltip
                            content="AICA can't fetch alerts for this"
                            direction="top"
                            contentCss={{ color: 'black', whiteSpace: 'nowrap' }}
                            fitContent
                            small
                            usePortal
                        >
                            <DisabledAlertsCell />
                        </Tooltip>
                    ) : (
                        <div
                            className={clsx(styles.Alerts, {
                                [styles.Alerts_Disabled]: !row?.alerts?.length,
                            })}
                            onClick={() => {
                                handleAlertsClick(row);
                            }}
                        >
                            <img
                                src={row?.alerts?.length ? alertIcon : alertIconDisabled}
                                alt="alert"
                                style={{
                                    margin: '0px 5px 2px 0',
                                }}
                            />
                            <span>{row?.alerts?.length} Alerts</span>
                        </div>
                    )}
                </td>
            )}
        </tr>
    );
}

export default SecondDegreeRow;
